import React, { useEffect, useState } from "react";
import "./overview-card.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
function OverviewCard() {
  
  const [watchList, setWatchList] = useState([]);
  const navigate = useNavigate();

  const [error, setError] = useState(null);
  const data= {
        "totalPartners": 1,
        "totalInvestors": 1,
        "totalBonds": 0,
        "totalActiveBonds": 0,
        "totalKycRequests": 22
    }
  const fetchWatchlist = async () => {
    const endpoint = `${base_url}/${api_type}/dashboardData`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      setWatchList(response?.data?.data); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchWatchlist();
  }, []);


  return (
    <section class="overview-cards">
      <div class="card cursor-pointer" onClick={()=>navigate('/registration/investor')}>
        <h2 class="card__title">No. Investor</h2>
        <div class="card__content">
          <span class="card__value">{watchList.totalInvestors || data.totalInvestors}</span>
          <span class="card__change card__change--positive">+11.01%</span>
        </div>
      </div>
      <div class="card cursor-pointer" onClick={()=>navigate('/registration/wealth-partner')}>
        <h2 class="card__title">No. Wealth Partner</h2>
        <div class="card__content">
          <span class="card__value">{watchList.totalPartners || data.totalPartners}</span>
          <span class="card__change card__change--negative">-0.03%</span>
        </div>
      </div>
      <div class="card cursor-pointer" onClick={()=>navigate('/investment-management/investor')}>
        <h2 class="card__title">No. Orders</h2>
        <div class="card__content">
          <span class="card__value">{watchList.totalBonds || data.totalBonds}</span>
          <span class="card__change card__change--positive">+15.03%</span>
        </div>
      </div>
      <div class="card cursor-pointer" onClick={()=>navigate('/registration/investor')}>
        <h2 class="card__title">KYC Request</h2>
        <div class="card__content">
          <span class="card__value">{watchList.totalKycRequests || data.totalKycRequests}</span>
          <span class="card__change card__change--positive">+6.08%</span>
        </div>
      </div>
    </section>
  );
}

export default OverviewCard;
